import { useState, useEffect } from 'react';
import { AgentVoice } from '../interfaces/Agent';

export default function useLoadAgentImage(
  imageFileName: string | null,
  voice?: AgentVoice,
  type: '40x40' | 'normal' = 'normal'
) {
  const [imgSrc, setImgSrc] = useState<string | null>(null);

  useEffect(() => {
    if (!imageFileName) {
      setImgSrc(null);
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        let mod;
        if (voice && type === 'normal') {
          mod = await import(
            `../assets/generated_agents/${voice}/${imageFileName}`
          );
        } else if (voice && type === '40x40') {
          mod = await import(
            `../assets/generated_agents/${voice}/40x40/${imageFileName}`
          );
        } else {
          mod = await import(`../assets/${imageFileName}`);
        }
        if (!cancelled) setImgSrc(mod.default ?? mod);
      } catch (err) {
        console.error('Failed to load agent image:', err);
        if (!cancelled) setImgSrc(null);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [imageFileName, voice, type]);

  return { imgSrc };
}
